import ReactDOM from 'react-dom/client';
import './index.css';
import BackOfficeApp from './BackOfficeApp';
import reportWebVitals from './reportWebVitals';

// בלי StrictMode בכוונה - הוא כפול-מפעיל effects בפיתוח (npm start) כדי
// לתפוס באגים, מה שגורם לכל קריאת SP-ראשונית-בטעינה (BOGetKashruts וכו')
// להישלח פעמיים בדפדפן בזמן פיתוח בלבד (לא קורה בבילד production/IIS)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<BackOfficeApp />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
